import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
const termsContent = <div className="space-y-6 text-ink-800 leading-relaxed" data-id="element-16">
    <h2 className="text-2xl font-serif font-bold text-ink-900" data-id="element-17">
      Términos y Condiciones
    </h2>
    <p className="text-sm text-ink-800/60" data-id="element-18">Última actualización: Mayo 2025</p>

    <h3 className="text-lg font-bold text-ink-900 mt-6" data-id="element-19">
      1. Aceptación de los Términos
    </h3>
    <p data-id="element-20">
      Al adquirir el producto digital "Método 3-3-3: Emprendimiento Express",
      aceptas estos términos y condiciones en su totalidad. Si no estás de
      acuerdo con alguno de estos términos, te pedimos que no realices la
      compra.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-21">2. Producto Digital</h3>
    <p data-id="element-22">
      El Método 3-3-3 es un producto digital (ebook en formato PDF y plantillas
      descargables) que se entrega de forma inmediata tras la confirmación del
      pago. No se trata de un producto físico ni de un servicio de consultoría
      personalizada.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-23">3. Uso del Producto</h3>
    <p data-id="element-24">
      El contenido adquirido es para uso personal y no comercial. Queda
      estrictamente prohibido:
    </p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-25">
      <li data-id="element-26">Reproducir, distribuir o compartir el contenido con terceros.</li>
      <li data-id="element-27">
        Revender, sublicenciar o redistribuir el material en cualquier formato.
      </li>
      <li data-id="element-28">
        Utilizar el contenido para crear productos derivados para la venta.
      </li>
    </ul>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-29">
      4. Garantía de Devolución
    </h3>
    <p data-id="element-30">
      Ofrecemos una garantía de devolución de 7 días naturales a partir de la
      fecha de compra. Para solicitar un reembolso, debes haber aplicado el
      método y armado al menos un kit. La solicitud debe realizarse dentro del
      plazo establecido.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-31">5. Resultados</h3>
    <p data-id="element-32">
      Los resultados mencionados en la página de venta son ejemplos reales pero
      no constituyen una garantía de ingresos. Los resultados individuales
      pueden variar dependiendo de factores como la ubicación, el esfuerzo
      invertido, el mercado local y la ejecución del método.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-33">6. Propiedad Intelectual</h3>
    <p data-id="element-34">
      Todo el contenido del Método 3-3-3, incluyendo textos, imágenes,
      plantillas y diseños, está protegido por derechos de autor. La compra
      otorga una licencia de uso personal, no la transferencia de propiedad
      intelectual.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-35">7. Modificaciones</h3>
    <p data-id="element-36">
      Nos reservamos el derecho de modificar estos términos en cualquier
      momento. Las modificaciones serán efectivas desde su publicación en esta
      página.
    </p>
  </div>;
const privacyContent = <div className="space-y-6 text-ink-800 leading-relaxed" data-id="element-37">
    <h2 className="text-2xl font-serif font-bold text-ink-900" data-id="element-38">
      Política de Privacidad
    </h2>
    <p className="text-sm text-ink-800/60" data-id="element-39">Última actualización: Mayo 2025</p>

    <h3 className="text-lg font-bold text-ink-900 mt-6" data-id="element-40">
      1. Información que Recopilamos
    </h3>
    <p data-id="element-41">
      Al realizar tu compra, recopilamos únicamente la información necesaria
      para procesar tu pedido:
    </p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-42">
      <li data-id="element-43">Nombre completo</li>
      <li data-id="element-44">Dirección de correo electrónico</li>
      <li data-id="element-45">
        Información de pago (procesada de forma segura por nuestro proveedor de
        pagos)
      </li>
    </ul>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-46">2. Uso de la Información</h3>
    <p data-id="element-47">Tu información personal se utiliza exclusivamente para:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-48">
      <li data-id="element-49">Procesar y entregar tu compra digital.</li>
      <li data-id="element-50">Enviarte el enlace de descarga del producto.</li>
      <li data-id="element-51">
        Comunicarnos contigo en caso de ser necesario respecto a tu pedido.
      </li>
    </ul>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-52">3. Protección de Datos</h3>
    <p data-id="element-53">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      tu información personal contra acceso no autorizado, alteración,
      divulgación o destrucción. No almacenamos información de tarjetas de
      crédito en nuestros servidores.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-54">4. Compartir Información</h3>
    <p data-id="element-55">
      No vendemos, intercambiamos ni transferimos tu información personal a
      terceros. La única excepción son los proveedores de servicios de confianza
      que nos asisten en la operación de nuestro negocio (procesadores de pago),
      quienes están obligados a mantener la confidencialidad de dicha
      información.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-56">5. Cookies</h3>
    <p data-id="element-57">
      Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
      navegación. Puedes configurar tu navegador para rechazar cookies, aunque
      esto podría afectar algunas funcionalidades del sitio.
    </p>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-58">6. Tus Derechos</h3>
    <p data-id="element-59">Tienes derecho a:</p>
    <ul className="list-disc pl-6 space-y-2" data-id="element-60">
      <li data-id="element-61">Acceder a la información personal que tenemos sobre ti.</li>
      <li data-id="element-62">Solicitar la corrección de datos inexactos.</li>
      <li data-id="element-63">Solicitar la eliminación de tus datos personales.</li>
      <li data-id="element-64">
        Retirar tu consentimiento para el uso de tus datos en cualquier momento.
      </li>
    </ul>

    <h3 className="text-lg font-bold text-ink-900" data-id="element-65">
      7. Cambios en esta Política
    </h3>
    <p data-id="element-66">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Te notificaremos sobre cambios significativos a través
      del correo electrónico proporcionado durante la compra.
    </p>
  </div>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-ink-900 py-8 px-4" data-id="element-67">
        <div className="max-w-4xl mx-auto text-center" data-id="element-68">
          <p className="text-cream-50/50 text-sm mb-4" data-id="element-69">
            © {new Date().getFullYear()} MÉTODO 3-3-3 — Emprendimiento Express.
            Todos los derechos reservados.
          </p>
          <div className="flex justify-center space-x-6" data-id="element-70">
            <button onClick={() => setActiveModal('terms')} className="text-cream-50/40 text-sm hover:text-gold-400 transition-colors cursor-pointer underline underline-offset-2" data-id="element-71">
              Términos y Condiciones
            </button>
            <span className="text-cream-50/20" data-id="element-72">|</span>
            <button onClick={() => setActiveModal('privacy')} className="text-cream-50/40 text-sm hover:text-gold-400 transition-colors cursor-pointer underline underline-offset-2" data-id="element-73">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-74">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-ink-900/70 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-75">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-76">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-blush-100 flex-shrink-0" data-id="element-77">
                <span className="text-sm font-bold text-emerald-900 uppercase tracking-wider" data-id="element-78">
                  {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
                </span>
                <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full bg-blush-50 flex items-center justify-center hover:bg-blush-100 transition-colors cursor-pointer" data-id="element-79">
                  <X className="w-4 h-4 text-ink-900" data-id="element-80" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 md:p-8 overflow-y-auto flex-grow" data-id="element-81">
                {activeModal === 'terms' ? termsContent : privacyContent}
              </div>

              {/* Modal Footer */}
              <div className="p-4 border-t border-blush-100 flex-shrink-0 text-center" data-id="element-82">
                <button onClick={() => setActiveModal(null)} className="px-6 py-2 bg-emerald-900 text-white rounded-lg text-sm font-bold hover:bg-emerald-800 transition-colors cursor-pointer" data-id="element-83">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}